<template>
  <div class="Footer">
    <div class="Footer--certificationContainer">
      <Title type="small">nos</Title>
      <Title>certifications</Title>
      <div class="Footer--certification">
        <img src="/img/global/certification/datadocke_.png" alt="Certification DataDocké"/>
        <img src="/img/global/certification/qualiopi_.png" alt="Certification Qualiopi"/>
      </div>
    </div>
    <div class="Footer--body">
      <div class="Footer-Decoration">
        <img class="Forme1" src="/img/global/forme1.svg" alt="forme1 home"/>
        <img class="Forme1" src="/img/global/forme1.svg" alt="forme1 home"/>
        <img class="Forme2" src="/img/global/forme2.svg" alt="forme2 home"/>
        <img class="Forme2" src="/img/global/forme2.svg" alt="forme2 home"/>
      </div>
      <div class="Footer-container">
        <div class="Footer-container-top">
          <div class="Footer-Social">
            <p>Suivez-nous sur</p>
            <a class="Socials" href="https://www.linkedin.com/company/jobstreamsas/" target="_blank">
              <img src="/img/global/social/linkedin.svg" alt="logo linkedin"/>
            </a>
          </div>
          <div class="Footer-Links">
            <p>
              <router-link to="/nous-connaitre/jobstream" @click.native="$scrollToTop();">
                À Propos
              </router-link>
            </p>
            <p>
              <router-link to="/mentions-legales" @click.native="$scrollToTop();">
                Mentions Légales
              </router-link>
            </p>
            <p>
              <router-link to="/CGV" @click.native="$scrollToTop();">
                Conditions Générales De Vente
              </router-link>
            </p>
            <p>
              <a target="_blank" href="./files/qualiopi/JS_Certificat_Qualiopi.pdf">
                Certificat Qualiopi
              </a>
            </p>
            <p>
              <router-link to="/politique-confidentialite" @click.native="$scrollToTop();">
                Cookies
              </router-link>
            </p>
            <p>
              <router-link to="/contact" @click.native="$scrollToTop();">
                Contact
              </router-link>
            </p>
          </div>
          <div class="Footer-Infos">
            <div class="Footer-Logo">
              <img src="/img/global/logo/logo-white.svg" alt="logo white jobstream"/>
            </div>
            <div class="Footer-Address">
              <p>230, rue Pierre Duhem</p>
              <p>13290 Aix en Provence</p>
            </div>
            <p class="Footer-Phone">
              <a href="tel:0482325001">
                04 82 32 50 01
              </a>
            </p>
            <p>
              <a href="mailto:contact@jobstream.fr">
                contact@jobstream.fr
              </a>
            </p>
          </div>
        </div>
        <div class="Footer-container-bottom">
          <div class="HBar"></div>
          <p>© 2026 - JobStream - TOUS DROITS RÉSERVÉS</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>
/* 
* Global 
*/
.Footer {
  position: relative;
  overflow: hidden;
}

.Footer >>> .Title-small span {
  color: #007ffd;
}

.Footer--body {
  background-color: #6D7076;
  position: relative;
}

.Footer * {
  font-size: 14px;
}

.Footer-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.Footer-container-top {
  width: 800px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  margin: 100px 0 45px 0;
}

a, p {
  text-decoration: none;
  color: #FFFFFF;
}

.Footer--certificationContainer {
  padding: 50px 0 20px 0;
  background: rgba(0, 0, 0, 0.03);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.Footer--certification {
  width: 500px;
  height: 225px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.Footer--certification img {
  display: block;
  flex: 0 0 auto;
  margin: 25px;
}

.Footer--certification img:nth-child(1) {
  width: 100px;
}

.Footer--certification img:nth-child(2) {
  width: 250px;
  background-color: white;
}

.Footer-Phone {
  margin-bottom: 10px;
}

/* 
* Decoration
*/

.Footer-Decoration {
  opacity: 0.1;
}

.Footer-Decoration img {
  position: absolute;
}

.Forme1 {
  width: 400px;
  transform: rotate(15deg);
}

.Forme2 {
  width: 70px;
}

.Forme1:nth-child(1) {
  top: -220px;
  right: -180px;
}

.Forme1:nth-child(2) {
  bottom: -220px;
  left: -180px;
}

.Forme2:nth-child(3) {
  top: 35px;
}

.Forme2:nth-child(4) {
  bottom: 35px;
  right: 0px;
}

/* 
* Socials 
*/
.Socials img {
  width: 20px;
  border-radius: 5px;
  position: relative;
  left: 50%;
  top: 25%;
  transform: translateX(-50%);
}

.Footer-Social p {
  font-weight: bold;
  margin-bottom: 20px;
}

.Socials {
  background: #FFFFFF;
  position: absolute;
  border-radius: 100%;
  width: 40px;
  height: 40px;
}

/* 
* Links 
*/
.Footer-Links p {
  margin-bottom: 20px;
  width: max-content;
}

/* 
* Infos
*/
.Footer-Infos {
  text-align: right;
}

.Footer-Logo {
  display: flex;
  justify-content: flex-end;
  padding-right: 0 !important;
}

.Footer-Logo img {
  width: 140px;
  display: block;
}

.Footer-Logo, .Footer-Address {
  margin-top: 10px;
  margin-bottom: 40px;
}

/* 
* Bottom
*/
.Footer-container-bottom {
  padding-top: 100px;
  width: 45%;
  text-align: center;
}

.Footer-container-bottom p {
  margin: 20px;
}

.HBar {
  height: 1px;
  opacity: 0.2;
  flex: 1;
  background-color: #FFFFFF;
}

/* 
* Responsive 
*/
@media (max-width: 880px) {
  /*
  * Decoration
  */
  .Forme1:nth-child(1) {
    top: -180px;
    right: -290px;
  }

  .Forme1:nth-child(2) {
    bottom: -230px;
    left: -300px;
  }

  .Forme2:nth-child(3) {
    top: 100px;
    left: -35px;
  }

  .Forme2:nth-child(4) {
    bottom: 150px;
    right: 0px;
  }

  /*
  * Top
  */
  .Footer-container-top {
    flex-direction: column;
    margin: 100px auto 0 auto;
  }

  .Footer-container-top p {
    text-align: center;
  }

  .Footer-container-top > div:not(:nth-child(2)) {
    margin-bottom: 100px;
  }

  .Footer-container-top > div:nth-child(2) {
    margin-bottom: 50px;
  }

  .Footer-container-top > div:nth-child(2) p {
    text-align: center;
    width: auto;
  }

  /*
  * Socials
  */
  .Socials {
    left: 50%;
    transform: translateX(-50%);
  }

  /*
  * Bottom
  */
  .Footer-container-bottom {
    width: 60%;
  }

  .Footer-Logo {
    justify-content: center;
    padding: 0 !important;
  }

  .Footer--certification {
    border-radius: 50px 50px 0 0;
  }
}

@media (max-width: 440px) {
  .Footer--certification {
    flex-direction: column;
    height: 300px;
  }
}
</style>